module.exports = "/images/jcb-icon.png";